<div class="grid" *ngIf="carInformacionInicial">
  <div class="col-12 md:col-12 lg:col-12 text-center">
    <i class="fa fa-refresh fa-spin fa-3x fa-fw"></i><br>
    <span>{{'LBL_CONSULTANDO' | translate }}</span>
  </div>
</div>
<div *ngIf="!carInformacionInicial">
  <div class="grid">
    <div class="col-12 md:col-12 lg:col-12">
      <h1 class="titulo-pagina">{{ 'HOMOLOGACIONESTADO.LBL_HOMOLOGACIONESTADOS' | translate}}</h1>
    </div>
  </div>
  <form [formGroup]="formulario" (ngSubmit)="onSubmit()" novalidate id="idFormulario" name="nomFormulario">
    <div class="grid">
      <div class="col-12 md:col-3 lg:col-3">
        <div class="div-form">
          <label>* {{ 'HOMOLOGACIONESTADO.LBL_FASE' | translate }}</label>
          <p-dropdown disableTab  id="idFase" name="nomFase" [options]="lisFase"
                      placeholder="{{ 'LBL_SELECCIONE' | translate}}" filter="filter"
                       formControlName="idFase" emptyFilterMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                      emptyMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                      optionValue="value"
                      optionLabel="label"
          ></p-dropdown>
          <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && f.idFase.invalid">
            {{ 'HOMOLOGACIONESTADO.LBL_FASE' | translate}} {{ 'LBL_REQUERIDO' | translate}}
          </div>
        </div>
      </div>
      <div class="col-12 md:col-3 lg:col-3">
        <div class="div-form">
          <label>* {{ 'HOMOLOGACIONESTADO.LBL_ESTADOSHIVAM' | translate }}</label>
          <p-dropdown disableTab  id="idEstadoShivam" name="nomEstadoShivam" [options]="lisEstadosShivam"
                      placeholder="{{ 'LBL_SELECCIONE' | translate}}" filter="filter"
                       formControlName="idEstadoShivam" emptyFilterMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                      emptyMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                      optionValue="value"
                      optionLabel="label"
          ></p-dropdown>
          <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && f.idEstadoShivam.invalid">
            {{ 'HOMOLOGACIONESTADO.LBL_ESTADOSHIVAM' | translate}} {{ 'LBL_REQUERIDO' | translate}}
          </div>
        </div>
      </div>
      <div class="col-12 md:col-3 lg:col-3">
        <div class="div-form">
          <label>* {{ 'HOMOLOGACIONESTADO.LBL_ESTADOANALIZAMOS' | translate }}</label>
          <p-dropdown disableTab  id="idEstado" name="nomEstado" [options]="lisEstados"
                      placeholder="{{ 'LBL_SELECCIONE' | translate}}" filter="filter"
                       formControlName="idEstado" emptyFilterMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                      emptyMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                      optionValue="value"
                      optionLabel="label"
          ></p-dropdown>
          <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && f.idEstado.invalid">
            {{ 'HOMOLOGACIONESTADO.LBL_ESTADOANALIZAMOS' | translate}} {{ 'LBL_REQUERIDO' | translate}}
          </div>
        </div>
      </div>
      <div class="col-12 md:col-3 lg:col-3">
        <div class="div-form">
          <label>* {{ 'HOMOLOGACIONESTADO.LBL_LINEACREDITO' | translate }}</label>
          <p-dropdown disableTab  id="idLineaCredito" name="nomLineaCredito" [options]="lisLineaCredito"
                      placeholder="{{ 'LBL_SELECCIONE' | translate}}" filter="filter"
                       formControlName="idLineaCredito" emptyFilterMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                      emptyMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                      optionValue="value"
                      optionLabel="label"
          ></p-dropdown>
          <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && f.idLineaCredito.invalid">
            {{ 'HOMOLOGACIONESTADO.LBL_LINEACREDITO' | translate}} {{ 'LBL_REQUERIDO' | translate}}
          </div>
        </div>
      </div>
    </div>
    <div class="grid form-footer-buttons">
      <div class="form-group col-12">
        <button icon="fa fa-plus" label="{{'BTN_GUARDAR' | translate }}"
                type="submit"
                pButton></button>
      </div>
    </div>
  </form>


  <div class="grid">
    <div class="col-12 md:col-6 lg:col-6">
    </div>
    <div class="col-12 md:col-6 lg:col-6">
      <input #gb type="text" pInputText size="40" placeholder="{{ 'LBL_BUSCAR' | translate }}"
             (input)="dt.filterGlobal($event.target.value, 'contains')"
             [(ngModel)]="busqueda" (change)="setBusqueda()">
    </div>
  </div>
  <div class="grid">
    <div class="col-12 md:col-12 lg:col-12">
      <p-table [columns]="columnas" #dt
               [value]="lisHomologacion" selectionMode="single" dataKey="idHomologacionEstado"
               [paginator]="true" [rows]="10"  paginatorPosition="bottom">
        <ng-template pTemplate="header" let-columns>
          <tr>
            <th *ngFor="let col of columns" [pSortableColumn]="col.field" [pSortableColumnDisabled]="!col.sort" class="text-center">
              {{col.header}}
              <p-sortIcon [field]="col.field" *ngIf="col.sort"></p-sortIcon>
            </th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-row>
          <tr [pSelectableRow]="row">
            <td>{{row.fase}}</td>
            <td>{{row.estadoShivam}}</td>
            <td>{{row.estado}}</td>
            <td>{{row.lineaCredito}}</td>
            <td class="text-center">
              <div class="btn-group" role="group">
                <button type="button" class="p-button p-button-success btn" icon="fa fa-trash" data-toggle="tooltip"
                        title="{{'BTN_INHABILITAR' | translate}}" pButton
                        (click)="inhabilitar(row)"></button>
              </div>
            </td>
          </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage" let-columns>
          <tr>
            <td [attr.colspan]="columns.length">
              {{ 'MSG_NOHAYREGISTROS' | translate}}
            </td>
          </tr>
        </ng-template>
      </p-table>
    </div>
  </div>
</div>

<p-confirmDialog #cd>
  <ng-template pTemplate="footer">
    <button type="button" pButton icon="fa fa-close" label="{{ 'LBL_NO' | translate }}" (click)="cd.reject()"></button>
    <button type="button" pButton icon="fa fa-check" label="{{ 'LBL_SI' | translate }}" (click)="cd.accept()"></button>
  </ng-template>
</p-confirmDialog>


